import type { NotificationItem } from '@packages/types';
import { applyRowUpdateToCache } from '../../lib/apply-row-update-to-cache';
import { mapRowsInCache, removeRowsFromCache } from '../../lib/list-cache-rows';

/** Marks one cached row read across every cached list variant; the row stays in the list. */
export function applyNotificationReadToCache(old: unknown, item: NotificationItem, readAt: string): unknown {
  return applyRowUpdateToCache(old, { ...item, readAt }, (cached, updated) =>
    cached.readAt === null ? updated : cached,
  );
}

/** Marks every unread cached row read, keeping an earlier `readAt` on rows already read. */
export function applyAllNotificationsReadToCache(old: unknown, readAt: string): unknown {
  return mapRowsInCache<NotificationItem>(old, (row) => (row.readAt === null ? { ...row, readAt } : row));
}

/** Drops one row from every cached list variant, for a notification another session already removed. */
export function removeNotificationFromCache(old: unknown, id: string): unknown {
  return removeRowsFromCache<NotificationItem>(old, (row) => row.id === id);
}
